import { render, staticRenderFns } from "./PublicRegionPage.vue?vue&type=template&id=2bd1547f&scoped=true"
import script from "./PublicRegionPage.vue?vue&type=script&lang=js"
export * from "./PublicRegionPage.vue?vue&type=script&lang=js"
import style0 from "./PublicRegionPage.vue?vue&type=style&index=0&id=2bd1547f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1547f",
  null
  
)

export default component.exports